export function infoOrPlaceholder(v:string|number|null|undefined):string {
    if (v === "" || v == null) {
        return "-"
    }

    return String(v) ?? "-"
}
